// Appariement de formes géométriques identiques (TGV, 2020) — Annexe 1
// Maps a raw score (X/12) to a percentile-class label.
// Médiane = 12, P5 = 10 from TGV norms; thresholds confirmed by user.
export function getTGVPCLabel(scoreInput) {
  const n = parseInt(scoreInput, 10);
  if (isNaN(n)) return null;
  if (n >= 12) return "PC > 50";
  if (n === 11) return "PC 10-20";
  if (n === 10) return "PC = 5";
  return "PC < 1";
}
